import { USER_SET_LOCALE, USER_SET_PROFILE, USER_CLEAR_PROFILE, USER_SET_PROFILE_ABOUT_PRIEST, USER_SET_COUNTRIES } from './mutations'
import api from '@/api/user'
import { loadLocale } from '@/locale/i18n'
import { BLOG_SET_ABOUT_PRIEST } from '../blog/mutations'

export default {
  setLocale: async ({ commit, state }, locale) => {
    commit(USER_SET_LOCALE, locale)
    await loadLocale(locale)
    if (state.id) {
      try {
        await api.saveLocale(locale)
      } catch (error) {
        console.log(error.message)
      }
    }
    localStorage.setItem('locale', locale)
  },
  loadProfile: async ({ commit }) => {
    try {
      const { profile } = await api.getProfile()
      commit(USER_SET_PROFILE, profile)
      await loadLocale(profile.locale || 'ru')
    } catch (error) {
      commit(USER_CLEAR_PROFILE)
      throw new Error(error.message)
    }
  },
  loadCountries: async ({ commit }) => {
    try {
      const { countries } = await api.loadCountries()
      commit(USER_SET_COUNTRIES, countries)
    } catch (error) {
      throw new Error(error.message())
    }
  },
  async sendFeedback ({ commit }, feedback) {
    try {
      return await api.sendFeedback(feedback.message, feedback.recipient)
    } catch (e) {
      throw new Error(e)
    }
  },
  updateProfile: async ({ commit }, profile) => {
    try {
      return await api.updateProfile(profile)
    } catch (error) {
      throw new Error(error.message)
    }
  },
  clearProfile: async ({ commit }) => {
    try {
      commit(USER_CLEAR_PROFILE)
    } catch (error) {
      throw new Error(error.message)
    }
  },
  saveAboutPriest: async ({ commit, rootState }, about) => {
    try {
      await api.updateAboutPriest(about)
      commit('BlogModule/' + BLOG_SET_ABOUT_PRIEST, { parish: rootState.ParishModule.current, info: about }, { root: true })
      commit(USER_SET_PROFILE_ABOUT_PRIEST, about)
    } catch (error) {
      throw new Error(error.message)
    }
  }
}
